<template>
    <div class="animated fadeIn">
        <div class="kgr-row">
            <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--top kgr-row">
                <div class="kgr-postfix__fluid">
                </div>
                <div
                    v-if="usabilityPassEnabledAndCreatable"
                    class="kgr-postfix__fixed"
                >
                    <button
                        class="kgr-button kgr-button--accent"
                        :disabled="!userHasSignature"
                        @click="openUsabilityPassDialog"
                    >
                        <kgr-icon
                            icon-class="add"
                            small
                            circle
                            highlight
                            class="kgr-button__icon kgr-button__icon--left"
                        />
                        <span>{{ $t('Brauchbarkeitspass erstellen') }}</span>
                    </button>
                </div>
            </div>
            <div class="kgr-grid kgr-grid--columnGutters kgr-grid--inlineBlock">
            </div>
        </div>

        <div class="animated fadeIn">
            <div
                v-if="showNoSignatureHint"
                class="kgr-alert kgr-alert--info kgr-row"
                v-html="tNoSignature"
            >
            </div>
            <table
                class="kgr-table kgr-table--block table-groups table-employees kgr-table--striped printable"
            >
                <thead>
                    <tr class="kgr-table__row">
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t("Ort") }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t("Ausstellungsdatum") }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t("Brauchbarkeit besteht für") }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions kgr-hidden-print">
                            {{ $t("Digital") }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions kgr-hidden-print">
                            {{ $t("Print") }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="usabilityPass in usabilityPasses"
                        :key="usabilityPass.id"
                        class="kgr-table__row"
                    >
                        <td class="kgr-table__cell">
                            {{ usabilityPass.location }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ usabilityPass.exhibitionDate }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ usabilityPass.getLevels().join(', ') }}
                        </td>
                        <td class="kgr-table__cell kgr-table__cell--actions kgr-hidden-print">
                            <a
                                :href="usabilityPass.urls.digitalDownload"
                                :title="$t('file.browser.download')"
                                class="kgr-table__action"
                            >
                                <kgr-icon-download />
                            </a>
                            <a
                                :href="usabilityPass.urls.digitalPreview"
                                :title="$t('file.browser.view')"
                                class="kgr-table__action"
                                target="_blank"
                            >
                                <kgr-icon-preview />
                            </a>
                        </td>
                        <td class="kgr-table__cell kgr-table__cell--actions kgr-hidden-print">
                            <a
                                :href="usabilityPass.urls.printDownload"
                                :title="$t('file.browser.download')"
                                class="kgr-table__action"
                            >
                                <kgr-icon-download />
                            </a>
                            <a
                                :href="usabilityPass.urls.printPreview"
                                :title="$t('file.browser.view')"
                                class="kgr-table__action"
                                target="_blank"
                            >
                                <kgr-icon-preview />
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <kgr-dog-usability-pass-dialog
            :dog-id="dogId"
            :show-dialog="showUsabilityPassDialog"
            :default-location="defaultLocation"
            @closeDialog="closeUsabilityPassDialog"
            @created="loadUsabilityPasses"
        />
    </div>
</template>

<script>
import ClubExam from '../../js/dto/club/ClubExam.js';
import DogRepository from '../../js/repository/DogRepository.js';
import DogUsabilityPassDialog from '../../components/dog/DogUsabilityPassDialog.vue';
import IconDownload from '../../components/common/icon/IconDownload.vue';
import IconPreview from '../../components/common/icon/IconPreview.vue';
import KgrIcon from '../../components/common/icon/Icon.vue';

export default {
    components: {
        'kgr-dog-usability-pass-dialog': DogUsabilityPassDialog,
        'kgr-icon': KgrIcon,
        'kgr-icon-preview': IconPreview,
        'kgr-icon-download': IconDownload,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        dogId: {
            type: String,
            required: true,
        },
        isClubEmployee: {
            type: Boolean,
            required: true,
        },
        usabilityPassEnabledAndCreatable: {
            type: Boolean,
            required: true,
        },
        userHasSignature: {
            type: Boolean,
            required: true,
        },
        defaultLocation: {
            type: String,
            required: true,
        },
        overviewUrl: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showUsabilityPassDialog: false,
            loading: false,
            usabilityPasses: [],
            examineeType: ClubExam.EXAMINEE_TYPE_DOG,
        };
    },
    computed: {
        showNoSignatureHint() {
            return this.isClubEmployee && !this.userHasSignature;
        },
        tNoSignature() {
            const link = '<a href="/backend/profile/settings-club" class="kgr-link">Einstellungen</a>';
            return this.$t('Um Brauchbarkeitspässe erstellen zu können, speichere bitte zunächst unter deinen {link} deine Signatur.', { link });
        },
    },
    created() {
        this.loadUsabilityPasses();
    },
    methods: {
        openUsabilityPassDialog() {
            this.showUsabilityPassDialog = true;
        },
        closeUsabilityPassDialog() {
            this.showUsabilityPassDialog = false;
        },
        loadUsabilityPasses() {
            this.loading = true;
            DogRepository.findAllUsabilityPasses(this.dogId)
                .then((usabilityPasses) => this.usabilityPasses = usabilityPasses)
                .catch((error) => {
                    this.$notify.error('error.loadingData');
                    console.error(error);
                })
                .finally(() => this.loading = false);
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
